import React from "react";
import { Button, Container, Title, Text } from "@mantine/core";
import { IconLink } from "@tabler/icons-react";
import styles from "./AdminPage.module.css";
import { ChatLayout } from "../../components/layout/ChatLayout";
import { useNavigate } from "@tanstack/react-router";


const ShowPreviewFeatures = import.meta.env.VITE_APP_SHOW_PREVIEW_FEATURES || "false";
const FeedbackReportLinkTest = import.meta.env.VITE_APP_FEEDBACK_REPORT_TEST;
const FeedbackReportLinkProd = import.meta.env.VITE_APP_FEEDBACK_REPORT_PROD;
const UsageReportLink = import.meta.env.VITE_APP_USAGE_REPORT;
const EngagementReportLink = import.meta.env.VITE_APP_ENGAGEMENT_REPORT;
const UniqueUserReportLink = import.meta.env.VITE_APP_UNIQUE_USER_REPORT;

export const AdminPage: React.FC = () => {
    const navigate = useNavigate();

    const isTestEnvironment = ShowPreviewFeatures === "true";

    const userFeedbackReportLink = isTestEnvironment
        ? FeedbackReportLinkTest
        : FeedbackReportLinkProd;

    const renderQuickLink = (label: string, onClick: () => void, id?: string) => (
        <Button
            key={label}
            variant="default"
            id={id}
            className={styles.quicklink}
            onClick={onClick}
            leftSection={<IconLink className={styles.quicklinkIcon} size={20} stroke={1.6} />}
        >
            {label}
        </Button>
    );

    return (
        <ChatLayout>
            <Container size="xl" className={styles.container}>
                <Title order={1} className={styles.title}>
                    Admin Options
                </Title>
                <div className={styles.sections}>
                    <section className={styles.section}>
                        <Text className={styles.subheading}>Reports</Text>
                        <div className={styles.quicklinkRow}>
                            {renderQuickLink("User Feedback Report", () => window.open(userFeedbackReportLink, "_blank"), "uf_report_button")}
                            {renderQuickLink("Usage Report", () => window.open(UsageReportLink, "_blank"), "usage_report_button")}
                            {renderQuickLink("Engagement Report", () => window.open(EngagementReportLink, "_blank"), "engagement_report_button")}
                            {renderQuickLink("Unique User Report", () => window.open(UniqueUserReportLink, "_blank"), "unique_user_report_button")}
                        </div>
                    </section>
                    <section className={styles.section}>
                        <Text className={styles.subheading}>Settings</Text>
                        <div className={styles.quicklinkRow}>
                            {renderQuickLink("Announcements", () => navigate({ to: "/announcements" }), "announcements_button")}
                        </div>
                    </section>
                </div>
            </Container>
        </ChatLayout>
    );
};
